<div class="row" [ngClass]="{ 'align-items-center': flowState === flowStates.NEW_EMAIL_INPUT }">
  <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.contact-data.email' | transloco }}</div>
  @switch (flowState) {
    @case (flowStates.VERIFIED) {
      <div class="col-11 col-sm-7">
        <span> {{ currentUser?.email }} </span>
        <span
          class="icon icon-18 align-content-center margin-left-10"
          [ngClass]="currentUser?.email && currentUser.emailVerified ? 'haken' : 'cross'"
        >
        </span>
      </div>
      <div class="col-1 text-right">
        <button
          class="btn btn-link p-0"
          (click)="this.flowState = flowStates.EDIT_START"
          [ngbTooltip]="'user-self-service.my-data.edit-button' | transloco"
          [openDelay]="500"
          placement="bottom"
        >
          <web-design-system-icon name="edit" />
        </button>
      </div>
    }
    @case (flowStates.EDIT_START) {
      <div class="col-12 col-sm-8">
        <div class="alert alert-primary zero-surface primary-900 border-0 py-4" role="alert">
          <h3 class="alert-heading mb-2">
            <strong> {{ 'user-self-service.my-data.contact-data.please-note' | transloco }} </strong>
          </h3>
          <p>{{ 'user-self-service.my-data.contact-data.if-not-email-access-text' | transloco }}</p>
          <p>{{ 'user-self-service.my-data.contact-data.if-email-access-text' | transloco }}</p>
          <div class="d-flex">
            <web-design-system-button class="ml-auto" size="small" (click)="startProcess()">
              {{ 'user-self-service.my-data.contact-data.change-email' | transloco }}
            </web-design-system-button>
          </div>
        </div>
      </div>
    }
    @case (flowStates.NEW_EMAIL_INPUT) {
      <div class="col-12 col-sm-8 pr-0">
        <form>
          <div class="form-row">
            <div class="input-group-material col-8">
              <input
                type="email"
                id="newEmail"
                name="newEmail"
                [(ngModel)]="newEmail"
                required
                #newEmailInput="ngModel"
                [placeholder]="'user-self-service.my-data.contact-data.new-email' | transloco"
              />
            </div>
            <div class="col-3 pt-1">
              <web-design-system-button class="ml-auto" size="small" (click)="saveNewEmail()" [disabled]="newEmailInput.invalid">
                {{ 'user-self-service.my-data.contact-data.next-button-text' | transloco }}
              </web-design-system-button>
            </div>
            <div class="col-1 pt-1">
              <button class="btn btn-link px-0 py-2" (click)="cancelProcess()">
                <web-design-system-icon name="cross" />
              </button>
            </div>
          </div>
        </form>
        <p class="text-color-error mb-0 mt-3">{{ error | transloco }}</p>
      </div>
    }
    @case (flowStates.TAN) {
      <div class="col-12 col-sm-8 pr-0">
        <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
      </div>
    }
    @case (flowStates.OLD_EMAIL_VERIFICATION) {
      <div class="col-12 col-sm-8">
        <div class="alert alert-primary zero-surface primary-900 border-0 py-4" role="alert">
          <h3 class="alert-heading mb-2">
            <strong> {{ 'user-self-service.my-data.contact-data.please-note' | transloco }} </strong>
          </h3>
          <p [innerHTML]="'user-self-service.my-data.contact-data.old-email-confirmation-text' | transloco"></p>
          <form>
            <div class="form-row">
              <div class="input-group-material col-8">
                <input
                  type="text"
                  id="oldEmailVerifCode"
                  name="oldEmailVerifCode"
                  [(ngModel)]="oldEmailVerifCode"
                  required
                  #oldEmailVerifCodeInput="ngModel"
                  [placeholder]="'user-self-service.my-data.contact-data.verification-code' | transloco"
                  min="6"
                  max="6"
                />
              </div>
              <div class="col-3 pt-1">
                <web-design-system-button
                  class="ml-auto"
                  size="small"
                  (click)="verificateOldEmail()"
                  [disabled]="oldEmailVerifCodeInput.invalid"
                >
                  {{ 'user-self-service.my-data.contact-data.next-button-text' | transloco }}
                </web-design-system-button>
              </div>
              <div class="col-1 pt-1">
                <button class="btn btn-link px-0 py-2" (click)="cancelProcess()">
                  <web-design-system-icon name="cross" />
                </button>
              </div>
            </div>
          </form>
          <p class="text-color-error mb-0 mt-3">{{ error | transloco }}</p>
        </div>
      </div>
    }
    @case (flowStates.NEW_EMAIL_VERIFICATION) {
      <div class="col-12 col-sm-8">
        <div class="alert alert-primary zero-surface primary-900 border-0 py-4" role="alert">
          <h3 class="alert-heading mb-2">
            <strong> {{ 'user-self-service.my-data.contact-data.please-note' | transloco }} </strong>
          </h3>
          <p [innerHTML]="'user-self-service.my-data.contact-data.new-email-confirmation-text' | transloco"></p>
          <form>
            <div class="form-row">
              <div class="input-group-material col-8">
                <input
                  type="text"
                  id="newEmailVerifCode"
                  name="newEmailVerifCode"
                  [(ngModel)]="newEmailVerifCode"
                  required
                  #newEmailVerifCodeInput="ngModel"
                  [placeholder]="'user-self-service.my-data.contact-data.verification-code' | transloco"
                  min="6"
                  max="6"
                />
              </div>
              <div class="col-3 pt-1">
                <web-design-system-button
                  class="ml-auto"
                  size="small"
                  (click)="verificateNewEmail()"
                  [disabled]="newEmailVerifCodeInput.invalid"
                >
                  {{ 'user-self-service.my-data.contact-data.next-button-text' | transloco }}
                </web-design-system-button>
              </div>
              <div class="col-1 pt-1">
                <button class="btn btn-link px-0 py-2" (click)="cancelProcess()">
                  <web-design-system-icon name="cross" />
                </button>
              </div>
            </div>
          </form>
          <p class="text-color-error mb-0 mt-3">{{ error | transloco }}</p>
        </div>
      </div>
    }
    @case (flowStates.FINISHED) {
      <div class="col-12 col-sm-8">
        <div class="alert alert-success zero-surface secondary-800 border-0 py-4" role="alert">
          <h3 class="alert-heading mb-2">
            <strong> {{ 'user-self-service.my-data.contact-data.please-note' | transloco }} </strong>
          </h3>
          <p>{{ 'user-self-service.my-data.contact-data.new-email-confirmed-text' | transloco }}</p>
        </div>
      </div>
    }
  }
</div>
